module.exports = __webpack_public_path__ + "static/img/icon_no_receive.9ea3d7bd.png";